import React from "react";

function Products() {
  return <h1 className="products">PRODUCTS</h1>;
}

export default Products;
